import React, {useEffect, useState} from 'react';
import { useDispatch } from 'react-redux';

import {hooks} from '../hooks';
import {theme} from '../constants';
import {components} from '../components';
import { logoutHandler } from '../services/logoutHandler';

export const SignOut: React.FC = () => {
  const navigate = hooks.useAppNavigate();
  const dispatch = useDispatch();

  const [rememberMe, setRememberMe] = useState<boolean>(false);
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const onLogout = async () => {
    setLoading(true); // شروع بارگذاری
    setError(null);  // پاک کردن پیام خطا
    const result = await logoutHandler(dispatch, navigate);

    setLoading(false); // پایان بارگذاری
  };
  const renderContent = (): JSX.Element => {
    return (
      <div
        style={{
          height: '100vh',
          padding: '20px',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <img
          src={require('../assets/icons/07.png')}
          alt='سفارش موفقیت‌آمیز'
          style={{
            width: 225.18,
            display: 'block',
            margin: '0 auto',
            marginBottom: 4,
          }}
        />
        <h2
          style={{
            textAlign: 'center',
            margin: 0,
            marginBottom: 14,
            textTransform: 'capitalize',
            color: theme.colors.mainColor,
            ...theme.fonts.Mulish_700Bold,
            fontSize: 22,
            fontWeight: 'bold',
          }}
        >
          آیا مطمئن هستید؟
        </h2>
        <p
          style={{
            fontSize: 16,
            lineHeight: 1.7,
            color: theme.colors.textColor,
            textAlign: 'center',
            whiteSpace: 'pre-line',
            marginBottom: 30,
          }}
        >
          آیا برای خروج مطمئن هستید ؟
        </p>
        <components.Button
          title='لغو'
          onClick={() => {
            navigate(-1);
          }}
          containerStyle={{marginBottom: 10, width: '100%'}}
        />
        <components.Button
          title='مطمئنم'
          onClick={onLogout}
          colorScheme='light'
          containerStyle={{width: '100%'}}
        />
      </div>
    );
  };

  return <>{renderContent()}</>;
};
